import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { BelieverAndAchiever } from './pages/BelieverAndAchiever';
import './styles/global.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/believer-and-achiever" element={<BelieverAndAchiever />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
